/**
 * Layout constants shared by the "Add Portal Access Grant" modal and the form
 * it hosts, so both halves of the modal stay visually consistent.
 */

// Wider than Mantine's "xl" (780px) so the two-column field rows below keep
// each input at a comfortable width.
export const MODAL_WIDTH = "900px";

// Half of a 12-column row — every field in this modal is paired.
export const HALF_ROW_SPAN = { base: 12, sm: 6 };

// Alert cards stop short of the body width so they read as call-outs rather
// than as another full-bleed section of the form, and stop growing entirely
// past a comfortable reading measure.
export const ALERT_WIDTH = "80%";
export const ALERT_MAX_WIDTH = 650;

// Puts a field's description under its input instead of between the label and
// the input, so a described field still lines up with its undescribed
// neighbour in the same Grid row.
export const DESCRIPTION_BELOW_INPUT: Array<
  "label" | "input" | "description" | "error"
> = ["label", "input", "description", "error"];
